export default __webpack_public_path__ + "static/Graphik-Bold-Web-93c6daec1b3a797bab248380a2ce6bc9.ttf";